import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { SetuMark } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full border border-border rounded-lg p-8 bg-card">
        <Link to="/" className="flex items-center gap-2.5 mb-6">
          <div className="w-8 h-8 rounded-md bg-primary grid place-items-center text-primary-foreground"><SetuMark size={22} strokeWidth={2.6} /></div>
          <span className="font-heading text-lg tracking-tight">Setubuild.OS</span>
        </Link>
        <div className="text-center py-4">
          <div className="w-16 h-16 mx-auto rounded-full bg-amber-500/10 grid place-items-center">
            <XCircle className="w-9 h-9 text-amber-500" />
          </div>
          <h1 className="font-display text-3xl mt-6">Payment cancelled</h1>
          <p className="text-muted-foreground text-sm mt-2">No charge was made. Your subscription is unchanged.</p>
          <Link to="/app/subscription" className="btn-sharp mt-8 w-full inline-flex items-center justify-center bg-primary text-primary-foreground py-3 font-medium" data-testid="try-again-btn">
            Try again
          </Link>
          <Link to="/app" className="mt-3 block text-sm text-muted-foreground hover:text-foreground">Back to dashboard</Link>
        </div>
      </div>
    </div>
  );
}
